import request from '@/config/axios'

export interface BrokerageWithdrawVO {
  id: number
  userId: number
  price: number
  feePrice: number
  totalPrice: number
  type: number
  userName: string
  userAccount: string
  bankName: string
  bankAddress: string
  qrCodeUrl: string
  status: number
  auditReason: string
  auditTime: Date
  remark: string
  payTransferId?: string | number
  transferChannelCode?: string
  transferTime?: Date
  transferErrorMsg?: string
}

// 查询佣金提现列表
export const getBrokerageWithdrawPage = async (params: any) => {
  return await request.get({ url: `/trade/brokerage-withdraw/page`, params })
}

// 查询佣金提现详情
export const getBrokerageWithdraw = async (id: number) => {
  return await request.get({ url: `/trade/brokerage-withdraw/get?id=` + id })
}

// 佣金提现 - 通过申请
export const approveBrokerageWithdraw = async (id: number) => {
  return await request.put({ url: `/trade/brokerage-withdraw/approve?id=` + id })
}

// 佣金提现 - 重新转账（仅对提现失败状态有效）
export const retryBrokerageWithdrawTransfer = async (id: number) => {
  return await request.put({ url: `/trade/brokerage-withdraw/re-transfer?id=` + id })
}

// 佣金提现 - 刷新灵工发放状态（仅提现中）
export const refreshFlexworkWithdraw = async (id: number) => {
  return await request.put({ url: `/trade/brokerage-withdraw/refresh-commission?id=` + id })
}

// 审核佣金提现 - 驳回申请
export const rejectBrokerageWithdraw = async (data: BrokerageWithdrawVO) => {
  return await request.put({ url: `/trade/brokerage-withdraw/reject`, data })
}
